import React, {useEffect, useRef, useState} from 'react';
import NavbarReturn from '../components/NavbarReturn';
import FooterAdmin from '../components/FooterAdmin';
import AlertBox from '../components/AlertBox';
import { collection, getDocs, doc, deleteDoc} from "firebase/firestore";
import { database } from '../config/firebaseConfig';
import { Toaster } from 'react-hot-toast';
import AlertOnLoading from '../components/AlertOnLoading';

function InquiriesAdmin() {
    const SUCCESS = "success";

    const WAIT_TIME = 1000; //Waits for 1s
    const notInitialRender = useRef(false);

    const [currentPage, setCurrentPage] = useState(1);
    const inquiriesPerPages = 5;

    const [newData, setNewData] = useState(true); //it functions to validate if it needs to re-render
    const [inquiries, setInquiries] = useState(null);

    const lastInquiryIndex = currentPage * inquiriesPerPages;
    const firstInquiryIndex = lastInquiryIndex - inquiriesPerPages;

    const togglePopupDelete = (inquirieId) =>{
        [].forEach.bind(document.getElementsByClassName(`popup_delete ${inquirieId}`),function(itm){
          itm.style.display = "flex";
        })();
    }
  
    const closePopupDelete = (inquirieId) =>{
        [].forEach.bind(document.getElementsByClassName(`popup_delete ${inquirieId}`),function(itm){
            itm.style.display = "none";
        })();
    }

    /*
        Deletes a Inquiry 
    */
    async function deleteInquirie(inquirieId) {
        const inquirieDoc = doc(database, "inquiries", inquirieId);
        await deleteDoc(inquirieDoc);
        setNewData(true);
        AlertBox(SUCCESS, '¡Consulta eliminada correctamente!');
        closePopupDelete(inquirieId)
    }

    /*
        Gets all Inquiries 
    */
    useEffect(() => {
            if (notInitialRender.current && newData){
                AlertOnLoading(WAIT_TIME+100);
            }else {
                notInitialRender.current = true;
            } 
            if (newData) {
                const inquiriesRef = collection(database, "inquiries");
                const getInquiries = async() => {
                    const data = await getDocs(inquiriesRef);
                    setInquiries(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
                }
                
                const interval = setInterval(() => { //Autorize re-render
                    getInquiries();
                    setNewData(!newData);
                }, WAIT_TIME);
                return () => clearInterval(interval);
            }
    }, [inquiries, newData])

    return (
        <div>
            <div>
            <Toaster
            toastOptions={{
            duration:3000,
        }}/>

            </div>
            
            <NavbarReturn />
            <div className='w-full h-navbar-mobile sm:h-navbar'></div>
            
            <div className='px-4 py-6 flex flex-col w-full h-auto bg-white lg:py-8 sm:px-8 min-h-screen'>
                
                <h2 className='lg:text-xl mt-6'>Todas las Consultas</h2>
                <span className='lg:w-80 w-48 border border-primary-100'></span>
                
                <div className='w-full flex flex-row justify-center'>
                    <div className='w-full flex flex-col justify-center items-center'>
                        {inquiries? inquiries.slice(firstInquiryIndex, lastInquiryIndex).map((inquiry)=> (
                            <div className='w-full flex justify-center'>
                                <div key={inquiry.id} className='max-w-table-web w-4/5 p-2 gap-2 grid grid-rows-9 mt-6 border border-primary-100 md:flex md:flex-col'>
                                    <div className='hidden md:grid gap-2'>
                                        
                                        <div className='flex flex-col space-y-2'>
                                            <div className='bg-primary-300 w-full h-9 flex justify-center items-center'>
                                                <h3 className='text-primary-100 text-sm lg:text-lg'>Correo Electrónico y Mensaje</h3>
                                            </div>

                                            <div className='bg-background w-full h-9 flex justify-center items-center'>
                                                <p className='text-navFont-100 text-base lg:text-xl font-bold'>{inquiry.email}</p>
                                            </div>
                                            <div className='bg-background w-full h-24 overflow-y-auto flex justify-center'>
                                                <p className='text-navFont-100 text-sm lg:text-lg text-center px-1'>{inquiry.message}</p>
                                            </div>

                                            <div className='w-full h-9 flex justify-center items-center'>
                                                <div className='mr-1 bg-primary-300 w-1/2 h-9 flex justify-center items-center'>
                                                    <h3 className='text-primary-100 text-sm lg:text-lg'>Nombre</h3>
                                                </div>
                                                <div className='ml-1 bg-primary-300 w-1/2 h-9 flex justify-center items-center'>
                                                    <h3 className='text-primary-100 text-sm lg:text-lg'>Teléfono</h3>
                                                </div>
                                            </div>

                                            <div className='w-full h-9 flex justify-center items-center'>
                                                <div className='mr-1 bg-background w-1/2 h-9 flex justify-center items-center'>
                                                    <p className='text-navFont-100 text-sm lg:text-lg'>{inquiry.name}</p>
                                                </div>
                                                <div className='ml-1 bg-background w-1/2 h-9 flex justify-center items-center'>
                                                    <p className='text-navFont-100 text-sm lg:text-lg'>{inquiry.phone}</p>
                                                </div>
                                            </div>

                                            <div className='bg-primary-300 w-full h-9 flex justify-center items-center'>
                                                <h3 className='text-primary-100 text-sm lg:text-lg'>Acción</h3>
                                            </div>

                                            <div className='w-full h-9 flex justify-center items-center bg-background'>
                                                <div className='ml-1 bg-background w-1/2 h-9 flex justify-center items-center'>
                                                    <button onClick={() => {togglePopupDelete(inquiry.id)}} 
                                                    className='w-full h-7 text-sm sm:text-base sm:h-9 bg-danger text-white rounded-md font-bold hover:bg-red-400'>Eliminar Consulta</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className='md:hidden bg-primary-300 w-full h-9 flex justify-center items-center'>
                                        <h3 className='text-primary-100 text-sm'>Correo Electrónico y Mensaje</h3>
                                    </div>

                                    <div className='md:hidden bg-background w-full h-9 flex justify-center items-center'>
                                        <h3 className='text-navFont-100 text-base font-bold'>{inquiry.email}</h3>
                                    </div>
                                    <div className='md:hidden bg-background w-full h-24 overflow-y-auto flex justify-center'>
                                        <p className='w-full text-center text-sm h-auto text-navFont-100 px-1'>
                                            {inquiry.message}
                                        </p>
                                    </div>

                                    <div className='md:hidden w-full h-9 flex justify-center items-center'>
                                        <div className='mr-1 bg-primary-300 w-1/2 h-9 flex justify-center items-center'>
                                            <h3 className='text-primary-100 text-sm'>Nombre</h3>
                                        </div>
                                        <div className='ml-1 bg-primary-300 w-1/2 h-9 flex justify-center items-center'>
                                            <h3 className='text-primary-100 text-sm'>Teléfono</h3>
                                        </div>
                                    </div>

                                    <div className='md:hidden w-full h-9 flex justify-center items-center'>
                                        <div className='mr-1 bg-background w-1/2 h-9 flex justify-center items-center'>
                                            <p className='text-navFont-100 text-sm'>{inquiry.name}</p>
                                        </div>
                                        <div className='ml-1 bg-background w-1/2 h-9 flex justify-center items-center'>
                                            <p className='text-navFont-100 text-sm'>{inquiry.phone}</p>
                                        </div>
                                    </div>

                                    <div className='md:hidden bg-primary-300 w-full h-9 flex justify-center items-center'>
                                        <h3 className='text-primary-100 text-sm'>Acción</h3>
                                    </div>

                                    <div className='md:hidden w-full h-9 flex justify-center items-center bg-background'>
                                        <div className='ml-1 bg-background w-1/2 h-9 flex justify-center items-center'>
                                            <button onClick={() => {togglePopupDelete(inquiry.id)}} 
                                            className='w-full h-7 text-sm sm:text-base sm:h-9 bg-danger text-white rounded-md font-bold hover:bg-red-400'>Eliminar Consulta</button>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className={`hidden relative z-40 popup_delete ${inquiry.id}`} aria-labelledby="modal-title" role="dialog" aria-modal="true" >
                                    <div className="fixed inset-0 bg-popup"></div>

                                    <div className="fixed inset-0 z-10 overflow-y-auto">
                                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                            <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                                <div className="sm:flex sm:items-start">
                                                <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                                    <svg className="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 10.5v3.75m-9.303 3.376C1.83 19.126 2.914 21 4.645 21h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 4.88c-.866-1.501-3.032-1.501-3.898 0L2.697 17.626zM12 17.25h.007v.008H12v-.008z" />
                                                    </svg>
                                                </div>
                                                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                                    <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">Eliminar Registro</h3>
                                                    <div className="mt-2">
                                                    <p className="text-sm text-gray-500">¿Está seguro que desea eliminar este registro? Este registro no se podrá recuperar. </p>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                                <button onClick={() => {deleteInquirie(inquiry.id);}} type="button" className="inline-flex w-full justify-center rounded-md border border-transparent bg-danger px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-400 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm">Eliminar</button>
                                                <button onClick={() => {closePopupDelete(inquiry.id);}} type="button" className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">Cancelar</button>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                        :
                        <div className='w-full flex h-footer-height justify-center items-center text-4xl text-primary-100 space-x-1'>
                            <svg fill='none' className="w-14 h-14 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                                <path clipRule='evenodd'
                                    d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                                    fill='currentColor' fillRule='evenodd' />
                            </svg>
                            <div>
                                Cargando...
                            </div>
                        </div>
                        }

                        <div className={`${inquiries?.length? "flex" : "hidden"} w-full items-center justify-evenly mt-5`}>
                            <span className={`text-sm text-gray-700`}>
                                Mostrando <span className="font-semibold text-gray-900">{lastInquiryIndex >= inquiries?.length? inquiries?.length:lastInquiryIndex}</span> de <span className="font-semibold text-gray-900">{inquiries?.length}</span> resultados
                            </span>
                            <div className="inline-flex mt-2 xs:mt-0">
                                <button
                                    onClick={() => {setCurrentPage(currentPage - 1)}} 
                                    className={`${currentPage === 1? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium rounded-l`}>
                                    Anterior
                                </button>
                                <button 
                                    onClick={() => {setCurrentPage(currentPage + 1)}}
                                    
                                    className={`${lastInquiryIndex >= inquiries?.length? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium border-0 border-l border-white rounded-r`}>
                                    Siguiente
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FooterAdmin />
        </div>
    )
}

export default InquiriesAdmin;